import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=378d8d20&scoped=true&"
import script from "./messenger.vue?vue&type=script&lang=js&"
export * from "./messenger.vue?vue&type=script&lang=js&"
import style0 from "./messenger.vue?vue&type=style&index=0&id=378d8d20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d8d20",
  null
  
)

export default component.exports